module.exports = __webpack_public_path__ + "static/media/github.3d81ef21.svg";